import { render, staticRenderFns } from "./LottieAutoPlayer.vue?vue&type=template&id=40a7ae95&scoped=true"
import script from "./LottieAutoPlayer.vue?vue&type=script&lang=js"
export * from "./LottieAutoPlayer.vue?vue&type=script&lang=js"
import style0 from "./LottieAutoPlayer.vue?vue&type=style&index=0&id=40a7ae95&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40a7ae95",
  null
  
)

export default component.exports